import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatLegacyDialog } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { selectUserBusinessDetails } from 'src/app/ngrx/user/user.selectors';
import { BeyButtonComponent } from '../bey-button/bey-button.component';

@Component({
  selector: 'verified-business-dialog-component',
  templateUrl: './verified-business-dialog-component.component.html',
  styleUrls: ['./verified-business-dialog-component.component.scss'],
  standalone: true,
  imports: [BeyButtonComponent],
})
export class VerifiedBusinessDialogComponentComponent implements OnDestroy {
  subs$: Subscription = new Subscription();
  constructor(private dialog: MatLegacyDialog, private router: Router, private store$: Store) {}

  onCancelClick(): void {
    this.dialog.closeAll();
  }

  onUploadDocumentsCancelClick(): void {
    this.subs$.add(
      this.store$.select(selectUserBusinessDetails).subscribe((details) => {
        if (details) {
          let { documents } = details;
          this.dialog.closeAll();
          this.router.navigate([`/business-documents${!!documents.length ? '' : '/upload'}`]);
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subs$.unsubscribe();
  }
}
